import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux' //Code

import axios from 'axios'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
//import { useDispatch } from 'react-redux'

import AuthService from '../../services/authService.js'
import CircularProgress from '@mui/material/CircularProgress'
//import ShiftService from '../../services/shiftService.js'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import {
    openFileDialog,
    closeDialog,
    toggleUpload,
    resetUploadToggle,
} from './fileSlice.js'

const mapStateToProps = (state) => ({
    isOpen: state.file.isOpen,
    associate: state.file.associate,
    resourceType: state.file.resourceType,
    doUpload: state.timesheet.doUpload,
})

const mapDispatchToProps = (dispatch) => {
    return {
        openDialog: () => {
            dispatch(openFileDialog())
        },

        closeDialog: () => {
            dispatch(closeDialog())
        },

        resetUploadToggle: () => {
            dispatch(resetUploadToggle())
        },
    }
}

const resource = {
    bls: 1,
    nurseLicense: 2,
    tb: 4,
    tbTestRecord: 4,
    hepatitis: 5,
    hepatitisBVaccineRecord: 5,
    flu: 6,
    fluVaccineRecord: 6,
    covidVaccineRecord: 7,
}

const File = (props) => {
    const fileType = props.resourceType
    const fileUpload = useRef(null)

    //const associate = shiftRequest.user

    //console.log(shift)
    const [fileUrl, setFileUrl] = React.useState('')
    const [isFilePDF, setIsFilePDF] = React.useState(false)

    const [file, setFile] = useState('') // storing the uploaded file
    const [dialogText, setDialogText] = useState('') // storing the uploaded file
    const [isFileDialogOpen, setIsFileDialogOpen] = useState(false)

    /*
    const handleFileUploadDialogClose = () => {
        setIsFileDialogOpen(false)
    }
    */

    // const [isClockDialogOpen, setIsClockDialogOpen] = React.useState(false)
    const loadFile = async () => {
        // clear dialog text on laod
        setDialogText('Searching Records...')
        setIsLoading(true)
        let headers = await AuthService.getHeader()

        let res
        let resourceType = props.resourceType
        console.log('resourece type ' + resourceType)

        let resourceTypeId = resource[resourceType]
        console.log('resourece type id' + resourceTypeId)

        const associate = props.associate
        try {
            let resourceUrl = `/api/facility/file/resource/${resourceTypeId}/${associate.id}`
            res = await axios.get(resourceUrl, {
                headers: headers,
            })
        } catch (e) {
            window.alert(
                'Sorry, there was an error. Please try again in a few seconds.'
            )
        }
        setIsLoading(false)
        // returns array of files, however, only 1 file supporte dat this time
        let fileObj = res.data
        let url = ''
        let msg = 'No record available. Please upload.'
        if (fileObj) {
            url = fileObj.urls[0]
            msg = ''
        }
        //setIsFileDialogOpen(true)
        setFileInfo(url)
        setDialogText(msg)
    }
    const handleOpenFileDialog = async () => {
        await loadFile()
        //setIsFileDialogOpen(true)
        return
    }

    const handleCloseFileDialog = () => {
        props.closeDialog()
        //setIsFileDialogOpen(false)
    }
    const handleUpload = async (e) => {
        //let e = window.event
        const file = e.target.files[0] // accessing file
        if (!file) {
            console.log('no file')
            return
        }
        // reset input file value
        e.target.value = null

        let resourceType = props.resourceType
        let resourceTypeId = resource[resourceType]
        setIsLoading(true)
        console.log(file)
        setFile(file) // storing file

        const data = new FormData()
        data.append('file', file)
        ///NOTE shift == shiftcollection and shiftcollection.shift = shift. confusing! todo fix
        data.append('resourceTypeId', resourceTypeId)

        /*
        for (let propertyName in shift) {
            data.append(propertyName, shift[propertyName])
        }
        */

        let headers = await AuthService.getHeader()
        let res = null
        try {
            res = await axios.post(
                `/api/nurse/file/resource/${resourceTypeId}`,
                //`/api/nurse/file/timesheet`,
                data,
                {
                    headers: headers,
                }
            )
        } catch (e) {
            window.alert(
                'Sorry, there was an error. Please try again in a few seconds.'
            )
        }

        /*
        try {
            if (res) {
                await UserService.getAccount()
            }
        } catch (e) {
            console.log(e)
            window.alert(
                'Sorry, there was an error. Please try again in a few seconds.'
            )
        }
        */

        setIsLoading(false)
        await loadFile()
        //handleCloseTimesheetDialog()
        //handleFileUploadDialogClose()
        //reload upload/view timesheets
        //await ShiftService.getAvailableShifts()
    }

    React.useEffect(() => {
        if (!props.isOpen) {
            // clear prior timesheet image
            setFileUrl('')
            setIsFilePDF(false)
            return
        }
        handleOpenFileDialog()
    }, [props.isOpen])

    React.useEffect(() => {
        if (!props.doUploadTimesheet) {
            // clear prior timesheet image
            return
        }
        //uploadTimesheet()
        props.resetTimesheetUploadToggle()
    }, [props.doUpload])
    const [isLoading, setIsLoading] = React.useState(false)
    const openTimesheetDialog = () => {
        props.openTimesheetDialog()
        /*
        props.openProfileDialog(
            props.shiftCollection,
            props.associateRequest,
            props.shift
        )
        */
    }

    const handleCloseTimesheetDialog = () => {
        //setIsClockDialogOpen(false)
        props.closeDialog()
    }
    /*
    const download = async resourceType => {
        let headers = await AuthService.getHeader()
        setIsLoading(true)
        let res = null
        let filename = null
        let resourceUrl = `/api/nurse/resource/${resourceType}`
        try {
            res = await axios.get(resourceUrl, {
                headers: headers
            })

            setIsLoading(false)
        } catch (e) {
            console.log('error getting file ' + JSON.stringify(e))
            if (e.response.status == 404) {
                alert(
                    'Sorry, file record not found. Please contact support@nurselab.co for 24/7 assistance.'
                )
            }
            setIsLoading(false)

            return
        }

        if (!res) {
            alert(
                'Error downloading file. Please try again later or contact us at support@nurselab.co for 24/7 assistance.'
            )
            return
        }
        let fileObj = res.data
        console.log(JSON.stringify(fileObj))
        // returns array of files, however, only 1 file supporte dat this time
        let url = fileObj.urls[0]
        setFileUrl(url)
        //setIsFileDialogOpen(true)

    }
        */

    const setFileInfo = (url) => {
        let tmpUrl = url.split('?')[0]
        if (tmpUrl.substr(-3).toLowerCase() === 'pdf') {
            setIsFilePDF(true)
        } else {
            setIsFilePDF(false)
        }

        setFileUrl(url)
    }

    const uploadFile = () => {
        fileUpload.current.click()
    }
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xl'))
    return (
        <div>
            <input
                type="file"
                accept="image/*"
                onChange={handleUpload}
                hidden
                ref={fileUpload}
            />
            <Dialog
                open={props.isOpen}
                onClose={handleCloseFileDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xl'}
            >
                <DialogTitle id="alert-dialog-title" />
                <DialogContent style={{ display: 'flex' }}>
                    {isFilePDF ? (
                        <embed
                            src={fileUrl}
                            style={{
                                display: 'block',
                                margin: 'auto',
                                minWidth: '30vw',
                                minHeight: '60vh',
                                maxWidth: fullScreen ? '100%' : '80vw',
                                maxHeight: fullScreen ? '100%' : '80vh',
                            }}
                        />
                    ) : (
                        <img
                            src={fileUrl}
                            alt=""
                            style={{
                                objectFit: 'contain',
                                maxWidth: fullScreen ? '100%' : '100%',
                                maxHeight: fullScreen ? '100%' : '100%',
                            }}
                        />
                    )}
                    {dialogText}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseFileDialog} color="primary">
                        Close
                    </Button>
                    {/*
                    <Button
                        color="primary"
                        autoFocus
                        onClick={() => fileUpload.current.click()}
                    >
                        New Upload
                    </Button>
                    /}
                    {/*
                    */}
                    <a
                        href={fileUrl}
                        style={{ textDecoration: 'none' }}
                        download
                    >
                        <Button color="primary" autoFocus>
                            Download
                        </Button>
                    </a>
                    {isLoading ? <CircularProgress /> : null}
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(File)
